class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.currentPage = 1;
    this.loading = false;
    this.finished = false;
    this.container = document.getElementById('ProductGridContainer');
    this.productGrid = document.getElementById('product-grid');
    this.pagination = document.querySelector('.pagination-wrapper');
    
    if (!this.container || !this.productGrid) return;
    
    this.init();
  }
  
  connectedCallback() {
    this.init();
  }
  
  init() {
    // Lấy trang hiện tại từ URL
    const urlParams = new URLSearchParams(window.location.search);
    this.currentPage = parseInt(urlParams.get('page')) || 1;
    
    // Ẩn pagination đi
    if (this.pagination) {
      this.pagination.style.display = 'none';
    }
    
    // Tạo loading indicator
    this.createLoadingIndicator();
    
    // Thêm event listener cho scroll
    window.addEventListener('scroll', this.throttle(this.handleScroll.bind(this), 200));
    
    // Thêm event listener cho filter changes
    this.observeFilterChanges();
  }
  
  createLoadingIndicator() {
    this.loadingIndicator = document.createElement('div');
    this.loadingIndicator.className = 'infinite-scroll-loading text-center padding-top';
    this.loadingIndicator.innerHTML = `
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <p class="mt-2">Loading...</p>
    `;
    this.loadingIndicator.style.display = 'none';
    this.container.appendChild(this.loadingIndicator);
  }
  
  handleScroll() {
    if (this.loading || this.finished) return;
    
    const scrollPosition = window.innerHeight + window.scrollY;
    const documentHeight = document.documentElement.offsetHeight;
    
    // Khi scroll đến cách bottom 500px thì load thêm
    if (scrollPosition >= documentHeight - 500) {
      this.loadNextPage();
    }
  }
  
  async loadNextPage() {
    if (this.loading || this.finished) return;
    
    this.loading = true;
    this.loadingIndicator.style.display = 'block';
    
    try {
      const nextPage = this.currentPage + 1;
      const currentUrl = new URL(window.location);
      currentUrl.searchParams.set('page', nextPage);
      
      // Thêm query parameters hiện tại để giữ filter
      const searchParams = currentUrl.searchParams.toString();
      const fetchUrl = `${currentUrl.pathname}?${searchParams}&view=ajax`;
      
      const response = await fetch(fetchUrl);
      const html = await response.text();
      
      // Parse HTML để lấy products
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newProducts = doc.querySelectorAll('#product-grid .grid__item');
      
      if (newProducts.length > 0) {
        // Thêm products vào grid
        const fragment = document.createDocumentFragment();
        newProducts.forEach(product => {
          // Re-initialize product card scripts
          this.reinitializeProductCard(product);
          fragment.appendChild(product);
        });
        
        this.productGrid.appendChild(fragment);
        this.currentPage = nextPage;
        
        // Check if there are more pages
        const nextPagination = doc.querySelector('.pagination__item--prev');
        if (!nextPagination) {
          this.finished = true;
          this.showEndMessage();
        }
      } else {
        this.finished = true;
        this.showEndMessage();
      }
    } catch (error) {
      console.error('Error loading next page:', error);
      this.showErrorMessage();
    } finally {
      this.loading = false;
      this.loadingIndicator.style.display = 'none';
    }
  }
  
  reinitializeProductCard(product) {
    // Re-trigger any product card initialization
    const event = new CustomEvent('productCardAdded', { detail: product });
    document.dispatchEvent(event);
  }
  
  showEndMessage() {
    const endMessage = document.createElement('div');
    endMessage.className = 'infinite-scroll-end text-center padding-top';
    endMessage.innerHTML = '<p>All products have been displayed</p>';
    this.container.appendChild(endMessage);
  }
  
  showErrorMessage() {
    const errorMessage = document.createElement('div');
    errorMessage.className = 'infinite-scroll-error text-center padding-top';
    errorMessage.innerHTML = '<p>An error occurred. Please try again.</p>';
    this.container.appendChild(errorMessage);
  }
  
  observeFilterChanges() {
    // Theo dõi thay đổi URL khi filter
    let currentUrl = window.location.href;
    
    const checkUrlChange = () => {
      if (window.location.href !== currentUrl) {
        currentUrl = window.location.href;
        this.reset();
      }
    };
    
    // Check mỗi giây
    setInterval(checkUrlChange, 1000);
  }
  
  reset() {
    this.currentPage = 1;
    this.loading = false;
    this.finished = false;
    
    // Xóa loading indicator cũ
    const oldLoading = this.container.querySelector('.infinite-scroll-loading');
    const oldEnd = this.container.querySelector('.infinite-scroll-end');
    const oldError = this.container.querySelector('.infinite-scroll-error');
    
    if (oldLoading) oldLoading.remove();
    if (oldEnd) oldEnd.remove();
    if (oldError) oldError.remove();
    
    this.createLoadingIndicator();
  }
  
  throttle(func, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  }
  
  disconnectedCallback() {
    // Cleanup event listeners khi element bị remove
    window.removeEventListener('scroll', this.handleScroll);
  }
}

// Đăng ký Custom Element
customElements.define('infinite-scroll', InfiniteScroll);

// Không cần khởi tạo tự động nữa vì đã có <infinite-scroll> trong HTML